import React from "react";
import Loader from "@liveramp/motif/core/Loader";

export default function SimpleDemo() {
  return <Loader />;
}
